import firebase from "firebase";
var firebaseConfig = {
  apiKey: "AIzaSyBzrQj3CGzc_kQEOr826iD3FLiiNVyUuP0",
  authDomain: "react-project-596e3.firebaseapp.com",
  projectId: "react-project-596e3",
  storageBucket: "react-project-596e3.appspot.com",
  messagingSenderId: "758420585927",
  appId: "1:758420585927:web:bea0da779556cff8792de2",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
